<template>
  <v-container>

    <h1 align="center" class="mb-2">VECOS HOME</h1>

    <v-row>
      <v-col cols="6">
        <v-btn color="vecos" height="150px" width="100%" size="x-large" 
        light @click="goToRicercaVerbale()">Crea <br> - <br> Ricerca <br> verbale</v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn color="vecos" height="150px" width="100%" size="x-large" 
        light @click="goToScadenziarioVerificheRidotto()">Scadenziario<br>verifiche<br>ridotto</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-btn color="vecos" height="150px" width="100%" size="x-large" 
        light @click="goToModificaFirma()">Modifica <br> firma</v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn color="vecos" height="150px" width="100%" size="x-large" 
        light @click="goToVeicoliAziendali()">Rendicontazione <br> viaggi <br> - <br> Carburante</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-btn color="vecos" height="150px" width="100%" size="x-large" 
        light @click="goToPianificazioneAttivita()">Pianificazione <br> - <br> chiusura <br> attività</v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn color="vecos" height="150px" width="100%" size="x-large" 
        light @click="goToGoogleMaps()">Google <br> Maps</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" align="center">
          <v-btn color="vecos" height="150px" width="100%" size="x-large"
          light @click="goToStraordinari()">Straordinari</v-btn>
      </v-col>
      <v-col cols="6" align="center">
          <v-btn color="vecos" height="150px" width="100%" size="x-large"
          light @click="goToSmartcal()">Calendario</v-btn>
      </v-col>
    </v-row>  
    <v-row>
      <v-col>
        <v-btn color="red" height="50px" width="100%" size="x-large"
          light @click="logout()">
            Logout
            <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-col>
    </v-row> 
     
  </v-container>


</template>

<script>
/*eslint-disable */

import { Conf } from "../conf/defaults";
import mixin from "../mixin/MixingCommonComp";


export default {
  mixins: [mixin],
  
  data() {
    return {

    }
  },
  methods:{
    goToRicercaVerbale(){
      this.$router.push("/ricercaVerbale");
    },
    goToVerbaliRecenti(){
      this.$router.push("/recenti");
    },
    goToEsportazioneVerbali(){
      this.$router.push("/esportazioneVerbali");
    },
    goToModificaFirma(){
      this.$router.push("/firma");
    },
    goToVeicoliAziendali(){
      this.$router.push("/veicoli");
    },
    goToPianificazioneAttivita(){
      this.$router.push("/pianificazioneAttivita");
    },
    goToGoogleMaps(){
      this.$router.push("/googleMaps");
    },
    goToSmartcal(){
      this.$router.push("/smartcal");
    },
    goToScadenziarioVerificheRidotto(){
      this.$router.push("/scadenziarioVerificheRidotto");
    },
    goToStraordinari(){
      this.$router.push("/straordinari");
    },
    logout() {
      this.$session.clear();
      this.$session.destroy();
      this.$router.push({ path: "/Login/" });
    }
  },
  computed: {
    buildNo: function () {
      return Conf.buildNo.replaceAll("-", "");
    },
  },
}

</script>